import Register from "../components/user/Register";
import Login from "../components/user/Login";
import Logout from "../components/user/Logout";
import LogoutEmailLogin from "../components/user/LogoutEmailLogin.vue";
import ForgotPassword from "../components/user/ForgotPassword";
import ResetPassword from "../components/user/ResetPassword";
import Activate from "../components/user/activate";
import VerifyEmail from "../components/user/VerfiyEmail";
import ChangeEmail from "../components/user/ChangeEmail.vue";
import LoginSocial from "../components/user/LoginSocial";
import AuthorizeAirtable from "../components/project/view/airtable/AirtableAuthorize.vue";
import UserDelete from "../components/user/Delete";

import ProfileObservations from "../components/user/profile/observations";
import ProfileProjects from "../components/user/profile/projects";
import ProfileInvites from "../components/user/profile/invites";
import ProfileAssignedLocations from "../components/user/profile/assignedLocations";
import ProfilePreferences from "../components/user/profile/preferences";
import ProfileDownloads from "../components/user/profile/downloads";
import ProfileShow from "../components/user/ProfileShow.vue";
import ProfileHome from "../components/user/profile/home/Stats.vue";

export default [
  {
    name: "Register",
    path: "/register/",
    component: Register,
    meta: { toHomeIfAuthenticated: true },
  },
  {
    name: "ProfileShow",
    path: "/users/profile",
    component: ProfileShow,
    meta: { requiresAuth: true },
    redirect: { name: "ProfileStats", hash: "#stats" },
    children: [
      {
        path: "/",
        name: "ProfileHome",
        redirect: { name: "ProfileStats", hash: "#stats" },
      },
      {
        path: "stats",
        name: "ProfileStats",
        component: ProfileHome,
      },
      {
        path: "invites",
        name: "ProfileInvites",
        component: ProfileInvites,
      },
      {
        path: "observations",
        name: "ProfileObservations",
        component: ProfileObservations,
      },
      {
        path: "projects",
        name: "ProfileProjects",
        component: ProfileProjects,
      },
      {
        path: "assigned_locations",
        name: "ProfileAssignedLocations",
        component: ProfileAssignedLocations,
      },
      {
        path: "downloads",
        name: "ProfileDownloads",
        component: ProfileDownloads,
      },
      {
        path: "preferences",
        name: "ProfilePreferences",
        component: ProfilePreferences,
      },
      {
        path: "*",
        name: "Profile404",
        component: ProfileShow,
      },
    ],
  },

  {
    name: "Login",
    path: "/login/",
    component: Login,
    meta: { toHomeIfAuthenticated: true },
  },
  {
    name: "Logout",
    path: "/logout/",
    component: Logout,
    meta: { toHomeIfAuthenticated: false },
  },
  {
    name: "LogoutEmailLogin",
    path: "/logout/email",
    component: LogoutEmailLogin,
    meta: { toHomeIfAuthenticated: false },
  },
  {
    name: "Activate",
    path: "/activate/:token?",
    component: Activate,
    meta: { requiresAuth: false },
  },
  {
    name: "VerifyEmail",
    path: "/register/verify",
    component: VerifyEmail,
    meta: { requiresAuth: false },
  },
  {
    name: "ChangeEmail",
    path: "/change-email/:token?",
    component: ChangeEmail,
    meta: { requiresAuth: true },
  },
  // { name: 'LoginGoogle', path: '/login/google', component: LoginSocial, meta: { toHomeIfAuthenticated: true }},
  // { name: 'LoginSciStarter', path: '/login/scistarter', component: LoginSocial, meta: { toHomeIfAuthenticated: true }},
  {
    name: "AuthorizeAirtable",
    path: "/integrations/airtable/authorize",
    component: AuthorizeAirtable,
    meta: { requiresAuth: true },
  },
  {
    name: "Delete",
    path: "/users/profile/delete",
    component: UserDelete,
    meta: { requiresAuth: true },
  },

  {
    name: "ForgotPassword",
    path: "/forgot-password/",
    component: ForgotPassword,
    meta: { toHomeIfAuthenticated: true },
  },
  {
    name: "UpdatePassword",
    path: "/update-password/",
    component: ForgotPassword,
    meta: { toHomeIfAuthenticated: true },
  },
  {
    name: "ResetPassword",
    path: "/reset-password/:token?",
    component: ResetPassword,
    meta: { toHomeIfAuthenticated: true },
  },
];
